import { toast } from "sonner";
import baseApi from "store/api/baseApi";

const fixedCostsApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    // Get all fixed costs
    getAllFixedCosts: builder.query({
      query: () => ({
        url: "fixedCosts/",
        method: "GET",
      }),
      providesTags: ["fixedcosts"],
      transformResponse: response => response.reverse(),
    }),

    // Get fixed cost by ID
    getFixedCostById: builder.query({
      query: id => ({
        url: `fixedCosts/${id}/`,
        method: "GET",
      }),
      providesTags: ["fixedcosts"],
    }),

    // Create fixed cost
    createFixedCost: builder.mutation({
      query: data => ({
        url: "fixedCosts/new",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["fixedcosts"],
      transformResponse: response => {
        toast.success("Fixed cost created successfully");
        return response;
      },
    }),

    // Update fixed cost
    updateFixedCost: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `fixedCosts/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["fixedcosts"],
      transformResponse: response => {
        toast.success("Fixed cost updated successfully");
        return response;
      },
    }),

    // Delete fixed cost
    deleteFixedCost: builder.mutation({
      query: id => ({
        url: `fixedCosts/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["fixedcosts"],
      transformResponse: response => {
        toast.success("Fixed cost deleted successfully");
        return response;
      },
    }),
  }),
});

export const {
  useGetAllFixedCostsQuery,
  useGetFixedCostByIdQuery,
  useCreateFixedCostMutation,
  useUpdateFixedCostMutation,
  useDeleteFixedCostMutation,
} = fixedCostsApi;